// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federkraft/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federkraftDE: PageEntry = {
  id: "post.federkraft",
  locale: "de",
  slug: "federkraft",
  seo: {
    title: "Glossar: Federkraft einfach erklärt | Dietz GmbH",
    description: "Die Federkraft ist die auf eine Feder wirkende Kraft, wenn sie gestreckt oder komprimiert wird. Sie ist direkt proportional zur Dehnung oder Kompression der Feder und hängt von der",
  },
  type: "post",
  h1: "Glossar: Federkraft einfach erklärt",
  intro: "Die Federkraft ist die auf eine Feder wirkende Kraft, wenn sie gestreckt oder komprimiert wird. Sie ist direkt proportional zur Dehnung oder Kompression der Feder und hängt von der Federkonstante ab. Die Federkraft kann berechnet werden durch Multiplikation der Federkonstante mit der Verformung der Feder. In technischen Anwendungen wird die Federkraft oft genutzt, um Bewegungen auszugleichen, Kräfte zu übertragen oder Speicherfunktionen zu erfüllen. Ein genaues Verständnis der Federkraft ist entscheidend für die richtige Anwendung von Federn in verschiedenen Ingenieurdisziplinen.",
  blocks: [

  ],
};
